module.exports = __webpack_public_path__ + "static/media/algorand-s3.a67e8fe7.jpg";